"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

import {
  trackPlatformPageView,
} from "@/lib/platform-analytics";

const TRACKED_PATHS = new Set([
  "/",
  "/fornecedores",
  "/como-funciona",
  "/planos",
  "/cadastro",
  "/login",
  "/pessoa-fisica/cadastro",
  "/empresa/cadastro",
]);

export default function PlatformAnalyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (!TRACKED_PATHS.has(pathname)) {
      return;
    }

    void trackPlatformPageView({
      path: pathname,
    });
  }, [pathname]);

  return null;
}
